@if (askInputForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="askInputForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Menu Text </label>
            </div>
            <clickatell-form-validation [controlName]="'text'"
            [form]="askInputForm"></clickatell-form-validation>
            <textarea class="control-textArea" activeForm [activeForm]="askInputForm" id="text"
            [formControlName]="'text'" placeholder="Enter menu text"></textarea>
          </div>
          <div class="control-div toggle-field">
            <div class="label-left-block">
              <label class="control-label"> Sensitive </label>
            </div>
            <div class="toggle-btn">
              <mat-slide-toggle [color]="'primary'" class="control-toggle"
                [formControlName]="'isPrivateVariable'">
              </mat-slide-toggle>
            </div>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Variable Name </label>
            </div>
            <clickatell-form-validation [controlName]="'varName'"
            [form]="askInputForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="askInputForm" id="varName"
              [formControlName]="'varName'" placeholder="Enter variable name">
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Validation Pattern </label>
              </div>
              <clickatell-form-validation [controlName]="'validationPattern'"
              [form]="askInputForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="askInputForm" id="validationPattern"
                [formControlName]="'validationPattern'" placeholder="Enter validation pattern">
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Cancel Input </label>
                </div>
                <clickatell-form-validation [controlName]="'cancelInput'"
                [form]="askInputForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="askInputForm" id="cancelInput"
                  [formControlName]="'cancelInput'" placeholder="Enter cancel input">
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Cancel Message </label>
                  </div>
                  <clickatell-form-validation [controlName]="'cancelMessage'"
                  [form]="askInputForm"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="askInputForm" id="cancelMessage"
                    [formControlName]="'cancelMessage'" placeholder="Enter cancel message">
                  </div>
                </ng-container>
              </ng-container>
            </clickatell-expansion-panel>
            <clickatell-expansion-panel>
              <ng-container header>
                <mat-panel-title>
                  Logic
                </mat-panel-title>
              </ng-container>
              <ng-container body>
                <ng-container [formGroup]="askInputForm">
                  <div class="control-result">
                    <div class="control-result-header">
                      Next
                    </div>
                    <div class="control-result-container">
                      <div class="control-div">
                        <label class="control-label">
                          <span class="pont-to">Point To</span>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        </label>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows"
                            [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps"
                            [flows]="nodeFlowDetails.flows"
                            [name]="'next'"
                            [form]="askInputForm"
                            [stepId]="nodeFlowDetails.stepId">
                          </next-selector>
                        }
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </clickatell-expansion-panel>
          </div>
        }